// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip__1f69d2b3","trigger":"trigger__1f69d2b3","content":"content__1f69d2b3"};